import siteNotFound from "../../assets/imgs/error-landing-page.png";
import { Grid2 } from "@mui/material";

const SiteNotFound = () => {
  return (
    <div className="content-body">
      <div
        style={{
          alignContent: "center",
          margin: "auto",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <img
          src={siteNotFound}
          alt="siteNotFound"
          style={{
            margin: "auto",
            height: "300px",
          }}
        />
        <h4
          style={{
            color: "#337ab7",
          }}
        >
          Site Not Found
        </h4>
      </div>

      <Grid2
        alignItems={"center"}
        justifyContent="center"
        container
        sx={{ marginTop: "2%" }}
      >
        <Grid2 item md={6}>
          <button
            className="create-btn"
            onClick={() => {
              window.location.href = "/";
            }}
          >
            Reload
          </button>
        </Grid2>
      </Grid2>
    </div>
  );
};

export default SiteNotFound;
